import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { BusinessCardComponent } from './business-card.component'

@NgModule({
  declarations: [BusinessCardComponent],
  imports: [CommonModule, IonicModule],
  exports: [BusinessCardComponent],
})
export class BusinessCardModule {}
